import { AlertCircle, AlertTriangle, CheckCircle2, Info, type LucideIcon } from 'lucide-react';

import { useToastStore, type ToastType } from '@/app/store/toast.store';

const ICONS: Record<ToastType, LucideIcon> = {
  success: CheckCircle2,
  info: Info,
  warning: AlertTriangle,
  error: AlertCircle,
};

export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="status" aria-live="polite">
      {toasts.map((t) => {
        const Icon = ICONS[t.type];
        return (
          <button
            key={t.id}
            type="button"
            className={`toast toast--${t.type}`}
            onClick={() => dismiss(t.id)}
          >
            <Icon />
            <span className="toast__message">{t.message}</span>
          </button>
        );
      })}
    </div>
  );
}
